var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Prototype",
    {
      attrs: {
        className: _vm.className,
        placeholder: _vm.placeholder,
        error: _vm.error,
        counter: _vm.counter,
        maxCount: _vm.maxCount,
        value: _vm.value,
        msg: _vm.msg,
        counterReg: _vm.counterReg,
        showMsg: _vm.showMsg,
        disabled: _vm.disabled,
        height: _vm.height
      },
      on: { blur: _vm.handleBlur, input: _vm.handleInput }
    },
    [
      _vm.isVerific && ((_vm.startVerific && _vm.isError) || _vm.isError)
        ? _c("div", { staticClass: "errmsg" }, [_vm._v(_vm._s(_vm.errmsgVal))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }